import cm from 'classnames';

import { SubscriptionType } from 'services/payment.service';
import { FREE_STORAGE_LIMIT } from 'constants/params';
import { useAppSelector } from 'store/store-hooks';
import { prettyBytes } from 'components/app/_helpers/_app.helper';

import styles from '../_app-container.module.scss';
import { useMemo } from 'react';

const MAX_PROGRESS = 90; // %

export const AppUser = () => {
  const { user, storage } = useAppSelector((state) => state.app__data);
  const prices = useAppSelector((state) => state.app__data.pricing.subscriptionPrices);

  const price = useMemo(() => {
    return prices.find((price) => price.type === user?.subscriptionType);
  }, [prices, user?.subscriptionType]);

  const limitSize = useMemo(() => {
    return (price?.storageLimit ?? FREE_STORAGE_LIMIT) * 1024 * 1024 * 1024;
  }, [price?.storageLimit]);

  const progress = useMemo(() => {
    return (storage.size / limitSize) * 100;
  }, [storage.size, limitSize]);

  const memoryUsage = useMemo(() => {
    return `${prettyBytes(storage.size) || '0 MB'} of ${prettyBytes(limitSize)} used`;
  }, [storage.size, limitSize]);

  return (
    <div className={styles.Modal__user}>
      <h3>
        {user?.firstName} {user?.lastName}
      </h3>
      <p>{user?.email}</p>
      <h4>
        <span>Storage</span>
        {price && (
          <b>
            {SubscriptionType[price.type]} <img src={price.image} className={styles.subscription} alt={price.name} />
          </b>
        )}
      </h4>
      <div className={cm(styles.progress, { [styles['progress--alert']]: progress > MAX_PROGRESS })}>
        <span style={{ width: progress + '%' }}></span>
      </div>
      <h5>{memoryUsage}</h5>
    </div>
  );
};
